import React from 'react'
import styles from '../styles.module.css'

const Table = ({ data, reportParams }) => {
  
  if (!data) return null;
  
  const {orgList, data: list} = data

  const renderRow = (heo, index) => {
    const values = list[heo]
    return (
      <tr>
        <th>{index + 1}</th>
        <th>{heo || 'Всего'}</th>
        {orgList.map(org => <td>{values[org] }</td>)}
        <td>{values['']}</td>
      </tr>
    )
  }


  return (
    <div className={styles.tableBlock}>
      <h3 className={"text-center mb-2"}>СВЕДЕНИЯ</h3>
      <h3 className={"text-center mb-2"}>о проведенных мероприятиях военно-профессиональной ориентации выпускников довузовских образовательных организаций Министерства обороны Российской Федерации</h3>
      <h3 className={"text-center mb-2"}>{`на поступление в высшие военно-учебные заведения в ${reportParams.year} году`}</h3>
      <table id='graduatesTable' className={styles.mainTable}>
        <thead>
          <tr>
            <th rowSpan={3}>№ п/п</th>
            <th rowSpan={3}>Наименование образовательной организации</th>
            <th colSpan={orgList.length}>Количество мероприятий военно-профессиональной ориентации выпускников ДОУ, проведенных представителями вузов МО РФ и ОВУ</th>
            <th rowSpan={3}>Всего</th>
          </tr>
          <tr>
            <th colSpan={orgList.length}>(в очном / заочном формате)</th>
          </tr>
          <tr>
            {orgList.map(org => <th key={org}>{org}</th>)}
          </tr>
        </thead>
        <tbody>
          {Object.keys(list).map(renderRow)}
        </tbody>
      </table>
    </div>
  )
}

export default Table